
export const APPLICATION_NOTES_TEXTAREA_MAXLENGTH = 280;